import { render, staticRenderFns } from "./editPricesModal.vue?vue&type=template&id=a02a82c0&"
import script from "./editPricesModal.vue?vue&type=script&lang=js&"
export * from "./editPricesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports